export default __webpack_public_path__ + "static/email-6a759d32d8b74572a9ecb8e1fa89b75d.webp";